import React from "react";

import {
    ICommandParameterModel,
    ParameterValidationRules,
} from "@formant/core/model/commandTemplate";
import { FormControl, FormItem, FormLabel, Input } from "@formant/ui-kit";

interface IValidationParametersProps {
    param: ICommandParameterModel;
    onUpdate: (updates: Partial<ICommandParameterModel>) => void;
}

export const ValidationParameters: React.FC<IValidationParametersProps> = ({
    param,
    onUpdate,
}) => {
    const updateValidation = (
        updates: Partial<ParameterValidationRules[typeof param.type]>,
    ) => {
        onUpdate({
            validations: {
                ...param.validations,
                ...updates,
            },
        });
    };

    const renderValidationFields = () => {
        switch (param.type) {
            case "string":
                return (
                    <div className="flex gap-4">
                        <FormItem>
                            <FormLabel>Minimum Length</FormLabel>
                            <FormControl>
                                <Input
                                    type="number"
                                    value={
                                        (
                                            param.validations as ParameterValidationRules["string"]
                                        )?.minLength ?? ""
                                    }
                                    onChange={e =>
                                        updateValidation({
                                            minLength: e.target.value
                                                ? parseInt(e.target.value, 10)
                                                : undefined,
                                        })
                                    }
                                    placeholder="Enter minimum length"
                                />
                            </FormControl>
                        </FormItem>

                        <FormItem>
                            <FormLabel>Maximum Length</FormLabel>
                            <FormControl>
                                <Input
                                    type="number"
                                    value={
                                        (
                                            param.validations as ParameterValidationRules["string"]
                                        )?.maxLength ?? ""
                                    }
                                    onChange={e =>
                                        updateValidation({
                                            maxLength: e.target.value
                                                ? parseInt(e.target.value, 10)
                                                : undefined,
                                        })
                                    }
                                    placeholder="Enter maximum length"
                                />
                            </FormControl>
                        </FormItem>

                        <FormItem>
                            <FormLabel>Regular Expression</FormLabel>
                            <FormControl>
                                <Input
                                    type="text"
                                    value={
                                        (
                                            param.validations as ParameterValidationRules["string"]
                                        )?.regexp ?? ""
                                    }
                                    onChange={e =>
                                        updateValidation({
                                            regexp: e.target.value || undefined,
                                        })
                                    }
                                    placeholder="Enter regular expression"
                                />
                            </FormControl>
                        </FormItem>
                    </div>
                );

            case "number":
                return (
                    <div className="flex gap-4">
                        <FormItem>
                            <FormLabel>Minimum Value</FormLabel>
                            <FormControl>
                                <Input
                                    type="number"
                                    value={
                                        (
                                            param.validations as ParameterValidationRules["number"]
                                        )?.min ?? ""
                                    }
                                    onChange={e =>
                                        updateValidation({
                                            min: e.target.value
                                                ? parseFloat(e.target.value)
                                                : undefined,
                                        })
                                    }
                                    placeholder="Enter minimum value"
                                />
                            </FormControl>
                        </FormItem>

                        <FormItem>
                            <FormLabel>Maximum Value</FormLabel>
                            <FormControl>
                                <Input
                                    type="number"
                                    value={
                                        (
                                            param.validations as ParameterValidationRules["number"]
                                        )?.max ?? ""
                                    }
                                    onChange={e =>
                                        updateValidation({
                                            max: e.target.value
                                                ? parseFloat(e.target.value)
                                                : undefined,
                                        })
                                    }
                                    placeholder="Enter maximum value"
                                />
                            </FormControl>
                        </FormItem>
                    </div>
                );

            default:
                return null;
        }
    };

    // Only show validation section for types that support validation
    if (!["string", "number"].includes(param.type)) {
        return null;
    }

    return <div className="space-y-4">{renderValidationFields()}</div>;
};
